import React, { useEffect, useState, useContext } from 'react';
import { Grid, FormLabel, FormHelperText, CircularProgress, Typography } from '@material-ui/core';
import { SecondaryButton, TextBox } from '../../../../Core/FormInput';
import AppContext from '../../../../App/AppContext';
import { getSalesEwipStatus, postSalesEwipStatus } from '../../../../Core/Service/wipSales-Services/salesEwip-service';
import { SketchPicker } from 'react-color';

const AddUpdateStatusColorModal = (props) => {
    const { showToast } = useContext(AppContext);
    const [loading, setLoading] = useState(false);
    const [btnLoader, setBtnLoader] = useState(false);
    const [state, setState] = useState({
        salesEwipStatusDescription: '',
        salesEwipStatusBackGroundColor: '#ffffff',
        salesEwipStatusForeColor: '#000000',
        errors: {}
    });

    useEffect(() => {
        const fetchHolidayType = async () => {
            if (props.salesEwipStatusID) {
                setLoading(true);
                try {
                    let res = await getSalesEwipStatus(props.salesEwipStatusID);
                    let data = res?.data?.list[0] || {};
                    if (res.success) {
                        setState((st) => ({
                            ...st,
                            salesEwipStatusDescription: data.salesEwipStatusDescription,
                            salesEwipStatusBackGroundColor: data.salesEwipStatusBackGroundColor || '#ffffff',
                            salesEwipStatusForeColor: data.salesEwipStatusForeColor || '#000000'
                        }));
                    }
                } finally {
                    setLoading(false);
                }
            }
        };
        fetchHolidayType();
    }, [props.salesEwipStatusID]);

    const handleInput = (e) => {
        const { name, value } = e.target;
        setState((st) => ({
            ...st,
            [name]: value
        }));
    };

    const handleValidation = () => {
        let errors = {};
        let formIsValid = true;

        if (!state.salesEwipStatusDescription.trim()) {
            formIsValid = false;
            errors.salesEwipStatusDescription = 'Description is required.';
        }

        setState((st) => ({
            ...st,
            errors: errors
        }));

        return formIsValid;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (handleValidation()) {
            setLoading(true);
            setBtnLoader(true);
            try {
                const data = {
                    salesEwipStatusID: props.salesEwipStatusID || null,
                    salesEwipStatusDescription: state.salesEwipStatusDescription,
                    salesEwipStatusBackGroundColor: state.salesEwipStatusBackGroundColor,
                    salesEwipStatusForeColor: state.salesEwipStatusForeColor
                };
                let res = await postSalesEwipStatus(data);
                if (res.data.success) {
                    showToast(`Status Color ${props.salesEwipStatusID ? 'Updated' : 'Added'} successfully`);
                    props.onClose(true);
                } else {
                    console.error(res.message);
                }
            } catch (error) {
                console.error('Error submitting data:', error);
            } finally {
                setLoading(false);
                setBtnLoader(false);
            }
        }
    };

    return (
        <div>
            {loading ? (
                <div style={{ margin: '325px 270px' }}>
                    <CircularProgress />
                    <Typography style={{ fontWeight: 'bold' }}>Loading...</Typography>
                </div>
            ) : (
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <FormLabel className="mandatoryfields" required>
                            Description
                        </FormLabel>
                        <TextBox onChange={handleInput} autoFocus value={state.salesEwipStatusDescription} name="salesEwipStatusDescription" />
                        {state.errors.salesEwipStatusDescription && (
                            <FormHelperText className="mandatoryfields">{state.errors.salesEwipStatusDescription}</FormHelperText>
                        )}
                    </Grid>

                    <Grid container spacing={2} style={{ marginLeft: -10, marginRight: 10 }}>
                        <Grid item xs={12} sm={6} style={{ textAlign: 'center', padding: 20 }}>
                            <FormLabel style={{ textAlign: 'center', padding: 10 }}>
                                <b>Background Colour</b>
                            </FormLabel>
                            <SketchPicker
                                color={state.salesEwipStatusBackGroundColor}
                                onChange={(color) => setState((st) => ({ ...st, salesEwipStatusBackGroundColor: color.hex }))}
                                width="100%"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} style={{ textAlign: 'center', padding: 20 }}>
                            <FormLabel style={{ textAlign: 'center', padding: 10 }}>
                                <b>Fore Colour</b>
                            </FormLabel>
                            <SketchPicker
                                color={state.salesEwipStatusForeColor}
                                onChange={(color) => setState((st) => ({ ...st, salesEwipStatusForeColor: color.hex }))}
                                width="100%"
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={12} style={{ marginTop: 20, marginBottom: 15 }}>
                        <SecondaryButton fullWidth isBtnLoader={btnLoader} onClick={handleSubmit}>
                            Submit
                        </SecondaryButton>
                    </Grid>
                </Grid>
            )}
        </div>
    );
};

export default AddUpdateStatusColorModal;
